import type { KeyboardEvent, ReactElement } from 'react';
import { EditorNumberField } from './editor-number-field';
import { FieldAlert } from './field-alert';

interface SurfaceNumberFieldProps {
  readonly label: string;
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly onKeyDown: (event: KeyboardEvent<HTMLInputElement>) => void;
  readonly onBlur: () => void;
  /** 이 칸 아래에 보일 거부 사유. null 이면 보이지 않는다. */
  readonly alert: string | null;
  readonly disabled?: boolean;
}

/** 표면 인스펙터의 자동 적용 숫자 칸 — 칸과 그 칸 바로 아래의 거부 사유를 한 묶음으로 둔다. */
export const SurfaceNumberField = ({
  label,
  value,
  onChange,
  onKeyDown,
  onBlur,
  alert,
  disabled = false,
}: SurfaceNumberFieldProps): ReactElement => (
  <div className="grid content-start gap-1">
    <EditorNumberField
      label={label}
      value={value}
      disabled={disabled}
      onChange={onChange}
      onKeyDown={onKeyDown}
      onBlur={onBlur}
    />
    <FieldAlert message={alert} />
  </div>
);
